(ns ncr.reports.details
  (:require
   [clojure.string :as str]
   [clojure.core.match :refer [match]]
   [uix.core.alpha :as uix]
   [ncr.etc.pf :as pf]
   [ncr.navigate :as n]
   [ncr.fragment.props.money :as money]
   [ncr.widgets.core :as w]
   [ncr.widgets.grid :as grid]))

(defn- c-fragment-links [{:keys [fragment flags]}]
  (let [url (n/fragment-href {:id fragment})]
    [:span
     fragment
     ": "
     (interpose " "
       (for [p flags]
         [:a {:key p :href (str url "#" p)} p]))]))

(defn- parts [{:keys [etype] :as v}]
  (case etype
    :form (map (:roles v) (:order v))
    :stack (map #(do [(:op v) %]) (:parts v))
    :atom nil))

(defn- c-context [{:keys [context etype] :as value}]
  [:span
   (case etype
     :atom
     (interpose ", "
       (for [[k v] context]
         (cond
           (string? k)
           [c-fragment-links {:key k :fragment k :flags v}]

           (keyword? k)
           (when (= 1 (count v))
             [:span (pr-str k) ": "
              (first v)]))))

     :form
     (let [{:keys [order roles]} value]
       [:<>
        (when (seq order)
          (->> order
            (map-indexed
              #(let [[op v] (roles %2)]
                 (str (if (zero? %1) "=" (name op)) " " %2)))
            (str/join " ")))
        " ..."])

     (str (count (parts value)) " more..."))])

(defn- expand-fn [cell-context]
  (let [row (grid/row cell-context)]
    (when (seq (.-subRows row))
      (fn [_] (.toggleExpanded row)))))

(def ^:private columns
  (clj->js
    [(grid/column-accessor :op
       (fn [cell-context]
         (match (grid/value cell-context)
           {:data {:op op}}
           [(merge
              {:style {:text-align "left"}}
              (when-let [expand-fn (expand-fn cell-context)]
                {:on-click expand-fn
                 :class ["ncr-expandable"]}))
            (let
              [row (grid/row cell-context)
               indent (str (* (.-depth row) 2) "rem")]
              [:span {:style {:padding-left indent}}
               [w/c-mdi-icon
                {:class (when-not expand-fn :ncr-m-visibility-hidden)
                 :icon (if (.getIsExpanded row) :chevron-down :chevron-right)}]
               " "
               (name op)])])))

     (grid/column-accessor :value "Value"
       (fn [cell-context]
         (match (grid/value cell-context)
           {:data {:value value}}
           [:span
            (when-let [expand-fn (expand-fn cell-context)]
              {:on-click expand-fn
               :class ["ncr-expandable"]})
            (money/to-string (:value value))]
           _
           nil)))

     (grid/column-accessor :role "Value"
       (fn [cell-context]
         (match (grid/value cell-context)
           {:data {:value {:role role}}}
           [:span (pr-str role) " "]

           _
           nil)))

     (grid/column-accessor :context "..."
       (fn [cell-context]
         (match (grid/value cell-context)
           {:data {:value value}}
           [:span
            (case (:etype value)
              :atom
              [c-context value]

              [:span
               (when-let [expand-fn (expand-fn cell-context)]
                 {:on-click expand-fn
                  :class ["ncr-expandable"]})
               (if (.getIsExpanded (grid/row cell-context))
                 "(collapse)"
                 [c-context value])])]

           _
           nil)))]))

(defn- part->row [[op v]]
  (let [parts (parts v)
        row {:type :value :data {:op op :value v}}]
    (cond-> row
      (seq parts)
      (assoc :sub-rows (mapv part->row parts)))))

(defn- part->simplified-row [[op v]]
  (let [parts (filter (comp :value peek) (parts v))
        row {:type :value :data {:op op :value v}}]
    (cond
      (not (seq parts)) row

      (and (= 1 (count parts)) (= :+ (get-in parts [0 0])))
      (recur (first parts))

      :else
      (assoc row :sub-rows (mapv part->simplified-row parts)))))

(defn- c-details [{:keys [value] :as props}]
  (let [parts (parts value)
        simplify (uix/state false)
        part->row (if @simplify part->simplified-row part->row)

        rows
        (uix/memo
          #(if-not (seq parts)
             [(part->row [:+ value])]
             (mapv part->row parts))
          [value part->row])]
    [:div
     [pf/c-checkbox
      {:label "Hide trivial nodes"
       :on-change #(reset! simplify %1)
       :is-checked @simplify
       :id "simplify-checkbox"
       :name "simplify"}]
     [grid/grid {:skip-header true} {:columns columns :rows rows}]]))

(defn render [props]
  [c-details props])
